import { useGetOrganizationWebhooksQuery } from '@/services/organizations';
import { OrganizationNode } from '@/types/Organizations';
import { Box, Button, useOpenClose } from '@palmetto/palmetto-components';
import { ErrorBoundary } from 'react-error-boundary';

import { EditWebhookRegistrationModal } from './EditWebhookRegistrationModal';
import { WebhookClientTable } from './WebhookClientTable';
import { WebhookLogChart } from './WebhookLogChart';

const Webhooks = ({ organization }: { organization: OrganizationNode }) => {
  const { alias } = organization;

  const {
    isOpen: isEditWebhookModalOpen,
    handleClose: handleEditWebhookModalClose,
    handleOpen: handleOpenEditWebhookModal,
  } = useOpenClose();

  const { data } = useGetOrganizationWebhooksQuery({ alias });
  const orgCount = Object.keys(data ?? {}).length;
  const descriptionText =
    orgCount > 1
      ? 'Setup and test webhooks for your visible organizations'
      : 'Setup and test webhooks for your organization';

  return (
    <Box
      childGap={{
        base: 'lg',
        desktop: '2xl',
        hd: '3xl',
      }}
      padding={{
        base: 'lg',
        desktop: '0',
      }}
      width="100%"
      display="block"
    >
      <Box direction="row" justifyContent="space-between">
        <Box childGap="2xs">
          <Box as="h2" fontSize="md" fontWeight="medium">
            Webhooks
          </Box>
          <Box as="p" color="body-secondary" fontSize="sm">
            {descriptionText}
          </Box>
        </Box>
        <Box>
          <Button onClick={handleOpenEditWebhookModal}>Create</Button>
        </Box>
      </Box>
      <WebhookClientTable organizationAlias={alias} />
      <ErrorBoundary fallback={<div>Error loading webhook chart.</div>}>
        <WebhookLogChart organizationAlias={alias} />
      </ErrorBoundary>
      <EditWebhookRegistrationModal
        organizationAlias={alias}
        isOpen={isEditWebhookModalOpen}
        handleClose={handleEditWebhookModalClose}
      />
    </Box>
  );
};

export default Webhooks;
